import aboutImg from "../images/about.jpg";

export default function About({ data, addRef }) {
  return (
    <section id="a-propos" style={{ background: "var(--white)" }}>
      <p className="section-label">{data.sectionLabel}</p>

      <div className="about-grid" ref={addRef}>
        <div className="about-text-block fade-in" ref={addRef}>
          <h2>
            {data.heading.split(data.headingEmphasis).map((part, i) => (
              <span key={i}>
                {part}
                {i === 0 && <em>{data.headingEmphasis}</em>}
              </span>
            ))}
          </h2>
          <p>{data.paragraphs[0]}</p>
          <div className="about-divider" />
          <p>{data.paragraphs[1]}</p>
        </div>

        <div className="about-image fade-in" ref={addRef} style={{ transitionDelay: "0.2s" }}>
          <div className="about-image-bg">
            <div className="about-img-fill" style={{ backgroundImage: `url(${aboutImg})` }} />
          </div>
          <div className="about-image-accent" />
        </div>
      </div>

      <div className="about-cards">
        {data.cards.map((card, i) => (
          <div
            className="about-card fade-in"
            key={card.num}
            ref={addRef}
            style={{ transitionDelay: `${i * 0.15}s` }}
          >
            <div className="about-card-num">{card.num}</div>
            <p className="about-card-title">{card.title}</p>
            <p className="about-card-text">{card.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
